// extracted by mini-css-extract-plugin
export default {"logo":"SignIn_logo__+iBB0","logo2":"SignIn_logo2__viuXq"};